module.exports = __webpack_public_path__ + "static/img/LT.489b9983.svg";